import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
 
export const store = new Vuex.Store({
    state: {
        //==============================================  
        homePageContents: null,
        baseInfo: null,
        //==============================================  
        userFullName: '',
        currentDate: '',
        mobNo: '',
        userGroup: '', 
        userName: '', 
        userGroupId : 0,  
        //==============================================
        confirm: {
            confirmationCodeHashId: '',
            timeRemaningForExpire: 0
        },
        //==============================================
    },

    getters: {
        //============================================== 
        
        readUserGroup: state => {
            return state.userGroup;
        },
        readUserGroupId: state => {
            return state.userGroupId;
        },
        readUserName: state => {
            return state.userName;
        }, 
        readUserFullName: state => {
            return state.userFullName;
        },
        readCurrentDate: state => {
            return state.currentDate;
        } 
    },
    mutations: {
        //============================================== 
        setHomePageContents: (state, data) => { 
            state.userGroup = data.UserGroup;
            state.userName = data.UserName;
            state.userFullName = data.UserFullName;
            state.currentDate = data.CurrentDate;
            state.userGroupId = data.UserGroupId
            if (data.IsUserLogined == false)
                localStorage.removeItem('accessToken');
        },
        //============================================== 
        setUserFullName: (state, data) => {
            state.userFullName = data;
        },
        //==============================================
        setConfirm: (state, data) => {
            state.confirm.confirmationCodeHashId = data.ConfirmationCodeHashId;
            state.confirm.timeRemaningForExpire = data.TimeRemaningForExpire;
        }, 
        //==============================================
    }
});